import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";

import routes from "routes.js";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      color: "transparent",
    };
    // this.toggle = this.toggle.bind(this);
    // this.dropdownToggle = this.dropdownToggle.bind(this);
    // this.sidebarToggle = React.createRef();
  }
  // toggle() {
  //   if (this.state.isOpen) {
  //     this.setState({
  //       color: "transparent",
  //     });
  //   } else {
  //     this.setState({
  //       color: "dark",
  //     });
  //   }
  //   this.setState({
  //     isOpen: !this.state.isOpen,
  //   });
  // }
  // dropdownToggle(e) {
  //   this.setState({
  //     dropdownOpen: !this.state.dropdownOpen,
  //   });
  // }
  getBrand() {
    let brandName = "Default Brand";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  }
  // openSidebar() {
  //   document.documentElement.classList.toggle("nav-open");
  //   this.sidebarToggle.current.classList.toggle("toggled");
  // }
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "dark",
      });
    } else {
      this.setState({
        color: "transparent",
      });
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateColor.bind(this));
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.sidebarToggle.current.classList.toggle("toggled");
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggle2() {
    this.setState({
      isOpen: false
    });
  }
  render() {
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <Navbar
        color={"dark"}
        expand="lg"
        className={"navbar-absolute fixed-top"}
      >
        <NavbarToggler onClick={() => { this.toggle() }}>
          <span className="navbar-toggler-bar bar1" />
          <span className="navbar-toggler-bar bar2" />
          <span className="navbar-toggler-bar bar3" />
        </NavbarToggler>
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {this.props.routes && this.props.routes.map((prop, key) => {
              return !prop.redirect ? (
                <NavItem>
                  <NavLink
                    key={key}
                    to={`${this.props.match.url}${prop.path}`}
                    className="nav-link"
                    activeClassName="active"
                    onClick={() => { this.toggle2() }}
                  >
                    {/* <i className={prop.icon} /> */}
                    <p>{prop.name}</p>
                  </NavLink>
                </NavItem>
              ) : <div key={key}></div>;
            })}
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default Header;
